if (typeof $ === "undefined" || $ === null) {
  libraries.jquery = false;
  console.error('jQuery is required, please make sure it is included before the cyclops script.');
}

if (typeof ko === "undefined" || ko === null) {
  libraries.knokcout = false;
  console.error('knockout is required, please make sure it is included before the cyclops script.');
}

if ((typeof $ === "undefined" || $ === null) || ($.ui == null)) {
  libraries.jqueryUi = false;
  console.log('jQuery UI is not referenced or is referenced after cyclops some parts of cyclops may not be avalible.');
} else {
  libraries.jqueryUi = true;
}

if (ko.validation == null) {
  libraries.knockoutValidation = false;
  console.log('knockout validation is not referenced or is referenced after cyclops some parts of cyclops may not be avalible.');
} else {
  libraries.knockoutValidation = true;
}

if (typeof moment === "undefined" || moment === null) {
  libraries.moment = false;
  console.log('momentjs is not referenced or is referenced after cyclops some parts of cyclops may not be avalible.');
} else {
  libraries.moment = true;
}

if (typeof Chartist === "undefined" || Chartist === null) {
  libraries.chartist = false;
  console.log('chartist is not referenced or is referenced after cyclops some parts of cyclops may not be avalible.');
} else {
  libraries.chartist = true;
}
